import { formatUsdcBaseUnits } from "@hybrid-escrow/shared";

/** Renders integer USDC base units via the shared formatter — never `Number(x) / 1e6`. */
export function Money({
  baseUnits,
  className,
}: {
  baseUnits: bigint | string;
  className?: string;
}) {
  const amount = typeof baseUnits === "string" ? BigInt(baseUnits) : baseUnits;
  return (
    <span className={["money", className].filter(Boolean).join(" ")}>
      ${formatUsdcBaseUnits(amount)}
      <span className="visually-hidden"> USDC</span>
    </span>
  );
}
